import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { IRequestCallback, RequestService } from '@df/api/request/request.service';
import { App } from '@df/core/app';
import { Status } from '@df/core/status';
import { Curalate } from './curalate.namespace';

@Injectable({
    providedIn: 'root'
})
export class CuralateService {
    protected request = inject(RequestService);
    protected app = inject(App);
    protected options = inject(Curalate.OPTIONS);
    protected readonly isPlatformBrowser = isPlatformBrowser(inject(PLATFORM_ID));

    /**
     * Crl8 getter
     * @returns {Curalate.ICrl8 | undefined}
     */
    get crl8(): Curalate.ICrl8 | undefined {
        if (this.isPlatformBrowser) {
            return window.crl8;
        }

        return undefined;
    }

    /**
     * Returns curalate sitename from config
     * @returns {string | undefined}
     */
    get sitename(): string | undefined {
        return this.options?.sitename;
    }

    /**
     * Loads curalate script
     * @param {Status}              status
     * @param {IRequestCallback}    onSuccess
     * @param {IRequestCallback}    onError
     */
    loadScript(status?: Status, onSuccess?: IRequestCallback, onError?: IRequestCallback): Promise<undefined> {
        return this.request.send(
            status,
            () => {
                return new Promise((resolve, reject) => {
                    if (typeof window !== 'undefined' && typeof document !== undefined && this.sitename) {
                        const crl8 = (window.crl8 || {}) as Curalate.ICrl8;
                        window.crl8 = crl8;
                        const document = window.document;
                        const scriptType = crl8.debug || document.location.search.indexOf('crl8-debug=true') !== -1 ? 'js' : 'min.js';

                        const scriptName = `${document.location.protocol}//cdn.curalate.com/sites/${this.sitename}/site/latest/site.${scriptType}`;

                        if (!this.request.isAssetLoaded(scriptName) && !this.request.isAssetLoading(scriptName)) {
                            let n = false;
                            const i: any[] = [];

                            crl8.ready = function (e) {
                                n ? e() : i.push(e);
                            };
                            crl8.pixel =
                                crl8.pixel ||
                                function () {
                                    crl8.pixel.q.push(arguments);
                                };
                            crl8.pixel.q = crl8.pixel.q || [];

                            this.request.loadScript(scriptName, {
                                onLoad: () => {
                                    n = true;
                                    i.forEach(function (e) {
                                        e();
                                    });
                                    resolve(undefined);
                                }
                            });
                        } else {
                            this.request.loadScript(scriptName, {
                                onLoad: () => {
                                    resolve(undefined);
                                }
                            });
                        }
                    } else {
                        reject();
                    }
                });
            },
            onSuccess,
            onError
        );
    }
}
